import { render, staticRenderFns } from "./BDropdownSidebar.vue?vue&type=template&id=613cca9d"
import script from "./BDropdownSidebar.vue?vue&type=script&lang=js"
export * from "./BDropdownSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports